import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./OutletAccordion.module.scss";

type Props = {
  open: boolean | undefined;
};

export const OUTLET_ACCORDION_INSTANCE_NAME = "outlet";

export function OutletAccordionUI({ open }: Props) {
  return (
    <Accordion
      className={styles["product-accordion__item"]}
      data-testid="accordion:outlet"
      label={"Outlet"}
      animated={true}
      responsive
      open={open}
      id="accordion-outlet"
      instanceName={OUTLET_ACCORDION_INSTANCE_NAME}
    >
      <div className={styles.outlet}>
        <span className={styles.heading}>
          Good as new returned items with up to 20% off
        </span>
        <p>
          Everything in our Outlet has been thoroughly checked by our expert
          Partners to make sure they meet our quality standards. They can be
          returned within 30 days and have the same guarantees as our new, full
          price items.
        </p>
        <span className={styles.heading}>Certified: Like new</span>
        <p>
          Meaning perfect condition, no bumps, scratches or marks. Usually only
          the box has been opened, or the item’s been repackaged.
        </p>
      </div>
    </Accordion>
  );
}
